/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  import/order */
import React, { FC, useEffect, useMemo, useState } from 'react';
import { Space } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Form, Tabs } from '~/components';
import { BusinessIcon, IndividualsIcon } from '~/img';
import { useGetApplication } from '~/controllers/wizard';
import { getStagePayload } from '~/utils/getStagePayload';
import IndividualTable from './IndividualTable';
import BusinessTable from './BusinessTable';
import BeneficialOwnerTable from './BeneficialOwnerTable';
import BeneficialOwnerAdditionalInformation from './BeneficialOwnerAdditionalInformation';
import { useGetDraft, useSaveDraft } from '~/controllers/draft';
import { getUpdatedShareholderData, getUpdatedShareholderDataSync } from '~/utils/contacts';
import { cloneDeep } from 'lodash';
import { Draft } from '~/types/Draft';

const ShareTables: FC = () => {
  const { t } = useTranslation('fillApplication');
  const globeState = useSelector((state: any) => state?.state);
  const { commonFormErrors } = globeState;
  const applicationQuery = useGetApplication();

  const individualHasError = useMemo(() => {
    if (!commonFormErrors) return false;
    return !!commonFormErrors['/wizard/application/shareholders']?.find((item: any) => item?.name[1] === 'individuals');
  }, [commonFormErrors]);

  const legalHasError = useMemo(() => {
    if (!commonFormErrors) return false;
    return !!commonFormErrors['/wizard/application/shareholders']?.find(
      (item: any) => item?.name[1] === 'beneficialOwners' || item?.name[1] === 'businesses',
    );
  }, [commonFormErrors]);

  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const errorFields = stagePayload?.activeStep.errorInformation?.errorFields;
  const individualHasWarnings = useMemo(() => {
    if (!errorFields) return false;
    return !!errorFields.find((errorObj) =>
      Object.keys(errorObj).find(
        (namePath) => namePath.includes('individuals') || namePath.includes('authorizedRepresentative'),
      ),
    );
  }, [errorFields]);
  const businessesHasWarnings = useMemo(() => {
    if (!errorFields) return false;
    return !!errorFields.find((errorObj) =>
      Object.keys(errorObj).find(
        (namePath) => namePath.includes('businesses') || namePath.includes('beneficialOwners'),
      ),
    );
  }, [errorFields]);

  if (!applicationQuery.data) {
    return null;
  }

  return (
    <>
      <StyledTabs defaultActiveKey="first" sticky centered>
        <StyledTabs.TabPane
          tab={
            <span data-error={individualHasError}>
              {/* <p>{individualHasError}</p> */}
              <IndividualsIcon />
              {t('Individual Shareholders')}
            </span>
          }
          key="first"
        >
          <div className="ShareTables-TabContent">
            <Form.Item name={['shareholders']} noStyle>
              <IndividualTable />
            </Form.Item>
          </div>
        </StyledTabs.TabPane>
        <StyledTabs.TabPane
          tab={
            <span data-error={legalHasError.toString()}>
              <BusinessIcon />
              {t('Legal Entity Shareholders')}
            </span>
          }
          key="second"
        >
          <div className="ShareTables-TabContent">
            <Space size={56} direction="vertical" style={fullWidth}>
              <Form.Item name={['shareholders']} noStyle>
                <BusinessTable />
              </Form.Item>
              <Form.Item name={['shareholders']} noStyle>
                <BeneficialOwnerTable />
              </Form.Item>
              <BeneficialOwnerAdditionalInformation />
            </Space>
          </div>
        </StyledTabs.TabPane>
      </StyledTabs>
    </>
  );
};

const fullWidth = { width: '100%' };

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 24px;
    z-index: 3;
  }
  .ant-table-empty {
    tbody {
      display: none;
    }
  }
  .ShareTables-TabContent {
    max-width: calc(100vw - ${16 * 2 + 8 * 2}px);
  }
`;

export default ShareTables;
